import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../Button';
import { SamsungIconBlack } from '../Icon';
import { StyledHeader, Title } from './Header.styles';
import { changeLanguage, getCurrentLanguage } from '@ciam/i18n';
import { useState } from 'react';
export const Header = ({ children }) => {
    const [lang, setLang] = useState(getCurrentLanguage().toUpperCase());
    const toggleLanguage = () => {
        const currentLang = getCurrentLanguage();
        const newLang = currentLang === 'ko' ? 'en' : 'ko';
        changeLanguage(newLang);
        setLang(newLang.toUpperCase());
    };
    return (_jsxs(StyledHeader, { children: [_jsxs(Title, { children: [_jsx(SamsungIconBlack, {}), _jsx("span", { children: "Business Account" })] }), children, _jsx(Button, { size: "xs", buttonTheme: "lined-blue", onClick: toggleLanguage, style: { marginLeft: 'auto', width: '4rem' }, children: lang })] }));
};
export default Header;
//# sourceMappingURL=Header.js.map